

import "./PrimaryNav.scss";
import Typography from "../Typography";
import FinkraftLogo from "static/images/FinLogo.png";
import {
  LeftOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { colorPicker } from "app/utils/color.helper";
export default function SubMenu(props: any) {
  const [activeMenu, setActiveMenu] = useState("");
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);
  const navigate = useNavigate();
  const toggleExpand = (menuKey: string) => {
    setExpandedMenu((prev) => (prev === menuKey ? null : menuKey));
  };
  return (
    <div className="PrimaryNavSubMenu">
      <div className="WorkspaceInfoContainer">
        <div className="LeftContent">
          <div className="IconBox">
            <Typography style={{ color: colorPicker("neutral.800") }}>
              {props.menuItems.title || "Credentials"}
            </Typography>
          </div>
        </div>
        <div className="CollapseAction" onClick={props.onClose}>
          <LeftOutlined />
        </div>
      </div>
      <div className="MenuContainer">
        {props.menuItems?.subMenus?.map((menu: any, key: any) => {
          const isExpanded = expandedMenu === menu.title;
          return (
            <div key={key}>
              <div
                className={
                  "MenuItem " + (activeMenu === menu.route ? " active" : "")
                }
                onClick={() => {
                  if (menu.subMenus && menu.subMenus.length > 0) {
                    toggleExpand(menu.title);
                  } else if (menu.route) {
                    navigate(menu.route);
                    setActiveMenu(menu.route);
                  }
                }}
              >
                {props.iconMap[menu.icon]}{" "}
                <Typography style={{ marginLeft: 6 }} variant="caption">
                  {menu.title}
                </Typography>
                {menu.subMenus && menu.subMenus.length > 0 && (
                  <span style={{ marginLeft: "auto" }}>
                    {isExpanded ? <UpOutlined /> : <DownOutlined />}
                  </span>
                )}
              </div>
              {/* Nested submenu */}
              {isExpanded && menu.subMenus && menu.subMenus.length > 0 && (
                <div className="SubMenuContainer" style={{ paddingLeft: 20 }}>
                  {menu.subMenus.map((sub: any, subKey: any) => (
                    <div
                      key={subKey}
                      className={
                        "MenuItem " +
                        (activeMenu === sub.route ? " active" : "")
                      }
                      onClick={() => {
                        navigate(sub.route);
                        setActiveMenu(sub.route);
                      }}
                    >
                      {props.iconMap[sub.icon]}{" "}
                      <Typography style={{ marginLeft: 6 }} variant="caption">
                        {sub.title}
                      </Typography>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}



